import { EditableContext } from "../common/EditableContextProvider";
import { useState, useContext } from "react";
import { App } from "antd";

export const FormSlidesComponent = () => {
    const { modal } = App.useApp();
    const { editItem, uploadSlide, deleteSlide } = useContext(EditableContext);
    const [loading, setLoading] = useState(false);

    const handle_submit = (e) => {
        e.preventDefault();
        uploadSlide(e.target.slide.files);
    }

    const delete_submit = (image) => {
        modal.confirm({
            content: '¿Eliminar Slide?',
            onOk: () => {
                deleteSlide(image);
            }
        });
    }

    return (
        <div>
            <form onSubmit={handle_submit}>
                <div className="row">
                    <div className="col-md-4 border-end">
                        <div className="mb-3">
                            <label className="form-label">Agregar Slide (tamaño[px]: 1366 x 500)</label>
                            <input
                                name="slide"
                                type="file"
                                className="form-control form-control-sm"
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <button
                                type="submit"
                                className="btn btn-sm btn-dark w-100"
                            >
                                Agregar
                            </button>
                        </div>
                    </div>
                    <div className="col-md">
                        {
                            editItem.slide_images ? editItem.slide_images.map((slide) => (
                                <div className="position-relative" key={slide}>
                                    <button className="position-absolute end-0" type="button"
                                        style={{ "border": "none", "background": "transparent", "padding": "0.8em" }}
                                        onClick={() => delete_submit(slide)}
                                    >
                                        <i className="fas fa-times text-danger"></i>
                                    </button>
                                    <img
                                        src={`/storage/${slide}`} alt=""
                                        className="w-100 py-1 my-1 border"
                                        style={{ maxHeight: '150px', objectFit: 'contain' }}
                                    />
                                </div>
                            )) : null
                        }
                    </div>
                </div>
            </form>
        </div>
    );
};
